import React from 'react';
import { Button } from '../ui/Button';
import { CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-[#f3e8ff] to-[#fdfbf7] pt-16 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-119">
      <div className="max-w-7xl mx-auto" data-id="element-120">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-121">
          <span className="inline-block py-1 px-3 rounded-full bg-purple-100 text-purple-800 text-sm font-semibold tracking-wide uppercase mb-4" data-id="element-122">
            El Código del Metabolismo Silencioso
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-123">
            ¿Barriga de estrés? Por qué el cardio está{' '}
            <span className="text-purple-600 italic" data-id="element-124">
              engordando tu abdomen
            </span>{' '}
            después de los 35.
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 max-w-2xl mx-auto leading-relaxed" data-id="element-125">
            Descubre el ritual nocturno de 15 minutos que desinflama tu abdomen
            mientras duermes.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-12 max-w-6xl mx-auto" data-id="element-126">
          {/* Book Image */}
          <div className="w-full md:w-1/2 flex justify-center relative" data-id="element-127">
            <div className="absolute inset-0 bg-purple-200 rounded-full filter blur-3xl opacity-30 transform scale-90" data-id="element-128"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9FeZWgjj3HNrFxfQeePiWJ/EL_CODIGO_DEL_METABOLISMO_SILENCIOSO.png" alt="El Código del Metabolismo Silencioso Libro" className="relative z-10 w-full max-w-md drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-129" />
          </div>

          {/* Key Benefits & CTA */}
          <div className="w-full md:w-1/2 space-y-8" data-id="element-130">
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-purple-50" data-id="element-131">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 font-heading" data-id="element-132">
                Lo que descubrirás dentro:
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-133">
                {['Por qué es tu cortisol, no tu dieta.', 'Cómo bajar 2 tallas sin pisar un gimnasio.', "El secreto de la 'Ventana Térmica Nocturna'.", 'Recupera tu energía en 21 días.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-134">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-135">
                      <CheckIcon className="h-4 w-4 text-green-600" data-id="element-136" />
                    </div>
                    <span className="ml-3 text-lg text-gray-700" data-id="element-137">{item}</span>
                  </li>)}
              </ul>

              <div className="space-y-4" data-id="element-138">
                <Button size="xl" fullWidth withIcon className="animate-pulse" onClick={() => {
                const el = document.getElementById('oferta-precio');
                if (el) el.scrollIntoView({
                  behavior: 'smooth'
                });
              }} data-id="element-139">
                  ¡Quiero mi Código de 21 Días!
                </Button>
                <p className="text-center text-sm text-gray-500" data-id="element-140">
                  Oferta Especial:{' '}
                  <span className="line-through text-gray-400" data-id="element-141">$97</span>{' '}
                  <span className="font-bold text-purple-700 text-lg" data-id="element-142">
                    $6.36 USD
                  </span>
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center gap-4 text-gray-500 text-sm" data-id="element-143">
              <div data-id="element-144">Descarga Inmediata</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}